import React, { useState } from 'react';
import { Box, Tabs, Tab, styled, } from '@mui/material';
import { People as PeopleIcon, EventNote as EventNoteIcon, Assessment as AssessmentIcon, Settings as SettingsIcon, } from '@mui/icons-material';
import EmployeeLeaveRequestManager from './employeeLeaveRequestManager';
import EmployeesLeaveBalanceList from './employeesLeaveBalanceList';
import EmployeesLeaveHistory from './employeesLeaveHistory';
import HolidayCalendarManager from './holidayCalendarManager';
import LeaveTypesManagement from './leaveTypesManagement';
import LeaveRequestsManager from '../../../components/common/leaveRequestsManager';


const StyledTabs = styled(Tabs)(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12,
    marginBottom: theme.spacing(3),
    padding: '6px',
    '& .MuiTabs-indicator': {
        height: 0,
    },
    '& .MuiTab-root': {
        fontWeight: 600,
        color: theme.palette.text.secondary,
        textTransform: 'none',
        minHeight: 48,
        borderRadius: 8,
        margin: '0 4px',
        '&.Mui-selected': {
            color: theme.palette.primary.main,
            backgroundColor: theme.palette.primary.light + '20',
        },
    },
}));

const HRLeaveManagement = () => {
    const [activeTab, setActiveTab] = useState(0);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    return (
        <Box>
            <StyledTabs
                value={activeTab}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
            >
                <Tab icon={<EventNoteIcon />} label="Leave Requests" />
                <Tab icon={<PeopleIcon />} label="Leave Balances" />
                <Tab icon={<AssessmentIcon />} label=" Employees Leave History" />
                <Tab icon={<EventNoteIcon />} label="Holiday Calendar" />
                <Tab icon={<SettingsIcon />} label="Leave Types" />
                <Tab icon={<AssessmentIcon />} label="My Leaves" />
            </StyledTabs>
            <Box>
                {activeTab === 0 && <EmployeeLeaveRequestManager />}
                {activeTab === 1 && <EmployeesLeaveBalanceList />}
                {activeTab === 2 && <EmployeesLeaveHistory />}
                {activeTab === 3 && <HolidayCalendarManager />}
                {activeTab === 4 && <LeaveTypesManagement />}
                {activeTab === 5 && <LeaveRequestsManager />}
            </Box>
        </Box>
    );
};

export default HRLeaveManagement;